import React from 'react';
import {Alert} from "react-bootstrap";
import lstrings from '../../../../utils/LStrings';
import moment from 'moment';
import {merge} from 'lodash';
import UI from '../../../../utils/UiUtils';
import ApiClient from '../../../../utils/ApiClient';
import PanelDatosParticulares from './components/PanelDatosParticulares';
import {INFO_KEY} from '../../../../config';
import Restringido from '../../../dashboard/components/restringido/Restringido';

class PersonasDetallePublic extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            token: props.match.params.token,
            statusDialogShow: false,
            restringido: true,
            mensaje_restringido: 'Se esta procesando la información, aguarde por favor.',
            requestInfoDialog: {
                show: false,
                blockName: '',
                subBlockName: ''
            },
            info: {
                datosParticulares: {
                    id: 0,
                    nombre: "",
                    apellido: "",
                    apellidoNombre: "",
                    cuil: 0,
                    dni: 0,
                    tipo: "",
                    nacionalidad: '',
                    anio: 0,
                    fechaNacimiento: '',
                    fechaDeceso: '',
                    edad: 0,
                    sexo: "",
                    mails: {
                        datos: [],
                        cantTotal: 0
                    },
                    domicilio: "",
                    localidad: "",
                    provincia: "",
                    domAlternativos: {
                        datos: [],
                        cantTotal: 0
                    }
                },
                codigo: '',
                idLog: 0
            },
            showPanels: {
                panelDatosParticulares: null
            },
            hidePanels: [],
            fecha: moment().format('DD/MM/YYYY HH:mm'),
            mostrarPDF: false
        };
    }

    componentDidMount() {
        UI.showProgress(true);
        ApiClient
            .getPersonPublic(this.state.token)
            .then(this.onFinishGetPerson)
            .catch(function (error) {
                UI.showProgress(false);
                UI.showError(error);
            });
    }

    onFinishGetPerson = (res) => {
        UI.showProgress(false);
        if (res.result.code === 200) {
            if (res.data) {
                this.state.restringido = false
                this.procesarInfo(res.data);
            } else {
                throw UI.handledError("No se encontraron resultados");
            }
        } else if (res.result.code === 405) {
            this.setState({restringido: true, mensaje_restringido: res.result.info})
        } else {
            throw UI.handledError(res.result.info);
        }
    }

    procesarInfo = (info) => {
        let hidePanels = this.hideSubPanels(info);
        let showPanels = this.mostrarPaneles(info);
        let newInfo = merge(this.state.info, info);
        this.setState({info: newInfo, showPanels: showPanels, hidePanels: hidePanels});
    }

    mostrarPaneles = (info) => {
        let showPanels = {
            panelDatosParticulares: true
        }

        return showPanels;
    }

    hideSubPanels = (info) => {
        let result = [];

        if (info.datosParticulares) {
            if (info.datosParticulares.domAlternativos === undefined) {
                result.push(INFO_KEY.domAlternativos);
                info.datosParticulares.domAlternativos = undefined;
            }
            if (info.datosParticulares.mails === undefined) {
                result.push(INFO_KEY.mails);
                info.datosParticulares.mails = undefined;
            }
        }

        return result;
    }

    onRequestInfo = (blockName, subBlockName) => {
        this.setState({
            requestInfoDialog: {
                show: true,
                blockName: blockName,
                subBlockName: subBlockName
            }
        });
    }

    render() {
        const restringido = <Restringido message={this.state.mensaje_restringido}/>
        
        const resultado = (
            <div>
                <div
                    className="col-md-12 resultado-busqueda -detalle resultado-busqueda -detalle2">
                    {this.state.showPanels.panelDatosParticulares && <PanelDatosParticulares
                        info={this.state.info.datosParticulares}
                        onRequestInfo={this.onRequestInfo}
                        hidePanels={this.state.hidePanels}/>}
                </div>
            </div>
        )

        const vista = (this.state.restringido)
            ? restringido
            : resultado;

        return (
            <div className={"col-md-12"}>
                {vista}
            </div>
        );
    }
}

PersonasDetallePublic.propTypes = {};

export default PersonasDetallePublic;



// WEBPACK FOOTER //
// ./src/scenes/personas/components/personas-detalle/PersonasDetallePublic.js